import { Component, OnInit, ViewChild } from '@angular/core';
import { SearchFieldsComponent } from '../search-fields/search-fields.component';
import { UserService } from '../shared/user.service';
import { Role } from '../shared/model/Role.model';
import { BossDependence } from '../shared/model/boss-dependence.model';
import { FilterRequest } from '../shared/model/filter-request.model';
import { RequestService } from '../shared/request.service';
import { RequestReponse } from '../shared/model/request-reponse.model';
import { UtilityService } from 'src/app/core/shared/utility.service';
import { RoleInformation } from 'src/app/core/shared/role-information.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-documents-reception',
  templateUrl: './documents-reception.component.html',
  styleUrls: ['./documents-reception.component.scss']
})
export class DocumentsReceptionComponent implements OnInit {

  rolUnidadAcademica: String = 'maresASISTRECONUNIDACAD';
  rolAistenciaIdiomas: String = 'maresASISTRECONIDIOMAS';
  roles: Role[] = [];
  bossDeependence: BossDependence;
  currentRol: Role;
  tipoRol: number;
  Requests: RequestReponse[];
  enabledSpinner = false;
  rolesApplication: Role[] = [];
  fileSearch: FilterRequest;
  constructor(private userService: UserService,
              private requestService: RequestService,
              private router: Router,
              private utilityService: UtilityService) { }

  ngOnInit() {
    this.getUserInformation();
  }

  changeSpinner(estado: boolean) {
    this.enabledSpinner = estado;
  }

  refreshSearch() {
    this.sendFilter(this.fileSearch);
  }

 sendFilter(event: FilterRequest) {
    event.estado = 'C';
    event.excluirEstado = true;
    this.enabledSpinner = true;
    this.fileSearch = event;
    if (this.currentRol.rol === this.utilityService.rolUnidadAcademica) {
      event.evaluador = localStorage.getItem('cedula');
      if ( event.tipo === 'MATERIA REGULAR') {
        this.requestService.getRequestAssistence(event).subscribe(
          (result) => {
            if (result.data) {
              this.Requests = result.data as RequestReponse[];
            }
            this.enabledSpinner = false;
          }
        );
      } else {
        this.requestService.getRequestAssistenceLeng(event).subscribe(
          (result) => {
            if (result.data) {
              this.Requests = result.data as RequestReponse[];
            }
            this.enabledSpinner = false;
          }
        );
      }
    } else if (this.currentRol.rol === this.utilityService.rolAistenciaIdiomas) {
      if ( event.tipo === 'MATERIA REGULAR') {
        event.evaluador = localStorage.getItem('cedula');
        this.requestService.getRequestAssistence(event).subscribe(
          (result) => {
            if (result.data) {
              this.Requests = result.data as RequestReponse[];
            }
            this.enabledSpinner = false;
          }
        );
      } else {
        this.requestService.getRequestAssistenceLeng(event).subscribe(
          (result) => {
            if (result.data) {
              this.Requests = result.data as RequestReponse[];
            }
            this.enabledSpinner = false;
          }
        );
      }
    } else {
      this.requestService.getRequest(event).subscribe(
        (result) => {
          if (result.data) {
            this.Requests = result.data as RequestReponse[];
          }
          this.enabledSpinner = false;
        }
      );
    }
 }

  private getUserInformation() {
    const userid =  null;
    const cedula =  localStorage.getItem('cedula');
    this.userService.getUserInformation(userid, cedula).subscribe(
      (result) => {
        if (result.data) {
            this.roles =  result.data.roles as Role[];
            this.bossDeependence = result.data.jefeDepartamento as BossDependence;
             const roleInformation: RoleInformation = this.utilityService.validateRole(this.roles, 1);
             this.rolesApplication = roleInformation.roles;
             this.currentRol = roleInformation.currentRol;
             this.tipoRol = roleInformation.tipoValidation;
             if (this.tipoRol  === 0) {
              const parameters = {
                tipo: 'info',
                mensaje: 'Usted no posee el rol adecuado para acceder a esta opción'
              };
              this.router.navigate(['message'], {queryParams : parameters});
             }

        }
      }
    );
  }


}
